module.exports = __webpack_public_path__ + "static/img/step1.e5b0e09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pages/task/step1.png
// module id = 7B+u
// module chunks = 30